exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#fgPortalFaqAccordion .card[data-v-259245da]{margin-bottom:10px;border:1px solid #e9edf0;border-radius:8px;overflow:hidden}#fgPortalFaqAccordion .card-header[data-v-259245da]{background:#f6f8f9;border-bottom:0}.fg-faq-header[data-v-259245da]{cursor:pointer;padding:14px 18px}#fgPortalFaqAccordion .card-body[data-v-259245da]{padding:14px 18px;font-size:14px;line-height:1.6;color:#647285;border-top:1px solid #eef1f3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-259245da","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/assets/js/franchise_component/faq_guideline/faq-guideline-portal.vue
// module id = c59z
// module chunks = 99